import { Component } from '@angular/core';

@Component({
  selector: 'app-big-loader',
  templateUrl: './big-loader.component.html',
  standalone: true
})
export class BigLoaderComponent {}
